import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { ROUTE_HOME } from '../../routes/routes.constants';

/**
 * Страница 404 для неизвестных путей.
 *
 * @returns {ReactElement}
 */
export function NotFound(): ReactElement {
  return (
    <main className='app-shell app-shell--error'>
      <h1 className='app-shell__title'>Страница не найдена</h1>
      <p className='app-shell__hint'>Запрошенный адрес отсутствует в приложении.</p>
      <p>
        <Link to={ROUTE_HOME}>На главную</Link>
      </p>
    </main>
  );
}
